import React from 'react';
import { Bell, User, Menu } from 'lucide-react';
import { useSchool } from '../context/SchoolContext';
import './Header.css';

const Header = ({ setIsSidebarOpen, isDesktop }) => {
    const { currentUser, getBranchName } = useSchool();

    return (
        <header className="top-header">
            <div className="header-left">
                {!isDesktop && (
                    <button className="menu-toggle" onClick={() => setIsSidebarOpen(true)}>
                        <Menu size={24} />
                    </button>
                )}
                <h1 className="page-title">Dashboard</h1>
            </div>

            <div className="header-actions">
                <div className="branch-selector">
                    <span className="branch-label">BRANCH</span>
                    <div className="branch-static-display">
                        {currentUser?.branch_id ? (getBranchName(currentUser.branch_id) || `Branch ${currentUser.branch_id}`) : 'Unassigned Station'}
                    </div>
                </div>

                <div className="notification-icon">
                    <Bell size={20} />
                    <span className="notification-dot"></span>
                </div>

                <div className="user-profile">
                    <div className="user-info">
                        <span className="user-name">{currentUser ? `${currentUser.first_name} ${currentUser.last_name}` : 'Staff Member'}</span>
                        <span className="user-role">{currentUser ? currentUser.assigned_role : 'Receptionist'}</span>
                    </div>
                    <div className="user-avatar">
                        <User size={20} />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
